import './menu.scss';

import React from 'react';
import { Link } from 'react-router';
import Fetch from 'network';
import Config from 'config';
import Cookies from 'js-cookie';

function clearAllCookie () {
  Cookies.remove(Config.SESSION_COOKIE_NAME, {
    path: '/',
    domain: Config.SESSION_COOKIE_DOMAIN
  });
  Cookies.remove(Config.USERINFO_COOKIE_NAME, {
    path: '/',
    domain: Config.SESSION_COOKIE_DOMAIN
  });
  window.location.reload();
}

function logout () {
  clearAllCookie();
}

export default (props) => {
  return (
    <ul className="menu">
      {props.items.map((item) => {
        return (
          <li className="menu-item" key={item.href}>
            <Link to={item.href} activeClassName="link-active">{item.title}</Link>
          </li>
        );
      })}
      <li className="menu-item"><a onClick={logout}>Logout</a></li>
    </ul>
  );
};



/** WEBPACK FOOTER **
 ** ./components/menu/index.js
 **/